import { useState } from 'react';

import { Box } from '@mui/material';

import { useGetTableEntries } from '../../../../shared/hooks/use-get-table-entries/use-get-table-entries.hook';
import { useGetTableResults } from '../../../../shared/hooks/use-get-table-results/use-get-table-results.hook';
import { useResetPageNumberAfterFiltering } from '../../../../shared/hooks/use-reset-page-number-after-filtering/use-reset-page-number-after-filtering.hook';
import { onChangeTableRowsPerPage } from '../../../../shared/utils/on-change-table-rows-per-page/on-change-table-rows-per-page.util';
import { onTablePageChange } from '../../../../shared/utils/on-table-page-change/on-table-page-change.util';
import { useAppDispatch } from '../../../../store/hooks';
import NoResults from '../../../shared/components/no-results/NoResults';
import SDCTable from '../../../shared/components/ui/Table/components/table/SDCTable';
import { getPaginationConfig } from '../../../shared/components/ui/Table/utils/get-pagination-config.util';
import { bulkActionHandler } from '../../../shared/utils/bulk-action-handler/bulk-action-handler.util';
import {
  addPagination,
  resetPagination,
} from '../../store/slices/web-game.slice';
import { getWebGamesTotalCount } from '../../thunks/get-web-games-total-count.thunk';
import { getWebGames } from '../../thunks/get-web-games.thunk';
import { WebGamesFiltersModel } from '../../thunks/models/web-games-filters.model';
import { webGamesTableColumns } from './defs/web-games-table-columns.util';
import { useGetWebGamesSelectors } from './hooks/use-get-web-games-selectors.hook';
import { useShowDeleteGamesModal } from './hooks/use-show-delete-games-modal.hook';

export const WebGamesTable = (): JSX.Element => {
  const {
    gamesFilters,
    webGames: tableRows,
    isLoading,
  } = useGetWebGamesSelectors();
  const {
    header: headerFilters,
    pagination: { pageNumber, totalCount, size },
  } = gamesFilters;

  const [ids, setIds] = useState<number[]>([]);
  const dispatch = useAppDispatch();

  const modalComponent = useShowDeleteGamesModal(ids, gamesFilters);

  useGetTableEntries<WebGamesFiltersModel>(
    headerFilters,
    getWebGamesTotalCount
  );

  useGetTableResults(gamesFilters, getWebGames);

  useResetPageNumberAfterFiltering(
    totalCount,
    pageNumber,
    size,
    resetPagination
  );

  return (
    <>
      <Box>
        {tableRows.length > 0 && (
          <SDCTable
            sx={{
              td: {
                wordWrap: 'break-word',
                overflow: 'hidden',
                padding: '25px 4px',
              },
            }}
            ariaLabel="web-games-table"
            bulkActions={true}
            bulkActionHandler={bulkActionHandler(setIds)}
            checkboxSelection={true}
            columns={webGamesTableColumns}
            rows={tableRows}
            stickyHeader={true}
            paginationConfig={getPaginationConfig(
              totalCount,
              size,
              pageNumber,
              onTablePageChange(dispatch, size, addPagination),
              onChangeTableRowsPerPage(dispatch, addPagination)
            )}
          />
        )}
        {tableRows?.length === 0 && !isLoading && <NoResults />}
      </Box>
      {modalComponent}
    </>
  );
};
